import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import {
  BaseTagEditorProps,
  TagEditor,
} from 'apps/TenantApp/components/tags/TagEditor';
import { SuspendWithRelativelyCenteredSpinner } from 'components/suspense/SuspendWithRelativelyCenteredSpinner';
import { OverlayProps } from 'components/TaskOverlay';
import React from 'react';
import { useFeatureFlag } from 'utils/sessionProvider';

export const TagModal = ({
  nodeId,
  readOnly,
  informOnEmpty,
  ...overlayProps
}: BaseTagEditorProps & OverlayProps) => {
  const isRenameTagsEnabled = useFeatureFlag('FEATURE_RENAME_TAGS_TO_LABELS');

  return (
    <Modal {...overlayProps}>
      <ModalOverlay />
      <ModalContent pb={3} data-qa="labels-modal-content">
        <ModalHeader>{isRenameTagsEnabled ? t`Labels` : t`Tags`}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <SuspendWithRelativelyCenteredSpinner>
            <TagEditor nodeId={nodeId} readOnly={readOnly} informOnEmpty />
          </SuspendWithRelativelyCenteredSpinner>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
